import { authRoutes } from '@/views/auth/auth.routes'
import { seniorRoutes } from '@/views/senior/senior.routes'
import { volunteerRoutes } from '@/views/volunteer/volunteer.routes'
import { requestChatsRoutes } from '@/views/request-chats/request-chats.routes'
import { devRoutes } from '@/views/dev/dev.routes'
import { errorRoutes } from '@/views/error/error.routes'
import { adminRoutes } from '@/views/admin/admin.routes'
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Root',
    component: () => null
  },

  ...authRoutes,
  ...seniorRoutes,
  ...volunteerRoutes,
  ...requestChatsRoutes,
  ...adminRoutes,
  ...devRoutes,
  ...errorRoutes,

  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

export {
  routes
}
